import type { OrderActionType } from 'state/secondaryMarket/shared/actions';

export const secondaryMarketAmendActionsFactory = <AmendRequest, AmendResponse, ActionType extends OrderActionType>(
  actionType: ActionType,
) => ({
  secondaryMarketAmendRequested: (tabId: string, orderId: string, etag: string, request: Partial<AmendRequest>) => ({
    type: `SECONDARY_MARKET_${actionType}_AMEND_REQUESTED` as const,
    tabId,
    orderId,
    etag,
    request,
  }),
  secondaryMarketAmendReceived: (tabId: string, data: AmendResponse) => ({
    type: `SECONDARY_MARKET_${actionType}_AMEND_RECEIVED` as const,
    tabId,
    ...data,
  }),
  secondaryMarketAmendFailed: (tabId: string, errorMessage?: string) => ({
    type: `SECONDARY_MARKET_${actionType}_AMEND_FAILED` as const,
    tabId,
    errorMessage,
  }),
  secondaryMarketAmendRejected: (tabId: string, errorMessage?: string) => ({
    type: `SECONDARY_MARKET_${actionType}_AMEND_REJECTED` as const,
    tabId,
    errorMessage,
  }),

  secondaryMarketAmendCollided: (tabId: string, errorMessage?: string) => ({
    type: `SECONDARY_MARKET_${actionType}_AMEND_COLLIDED` as const,
    tabId,
    errorMessage,
  }),
});
